module.exports = __webpack_public_path__ + "img/providers-new.0a9f89e.webp";